var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliancediligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15437"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#363637"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.984 11C20.9272 11.0074 19.9163 11.3789 19.1705 12.0341C18.4248 12.6893 18.0042 13.5753 18 14.5H16C14.686 14.5 13.644 14.605 12.766 14.8937C11.888 15.1807 11.186 15.7005 10.77 16.3602C9.94 17.6762 10.03 19.288 10 21.4895V30.2605C10.03 32.462 9.94 34.0737 10.77 35.3915C11.186 36.0495 11.89 36.5693 12.766 36.858C13.644 37.145 14.686 37.25 16 37.25H23.524C23.1102 36.7051 22.7756 36.1173 22.528 35.5H16C14.816 35.5 13.99 35.3897 13.47 35.22C12.95 35.0485 12.726 34.8647 12.524 34.5427C12.12 33.9023 12.03 32.4532 12 30.25V21.5C12.03 19.2968 12.12 17.8477 12.524 17.2072C12.726 16.8853 12.95 16.6997 13.47 16.53C13.99 16.3585 14.816 16.25 16 16.25V17.9983H28V16.25C29.186 16.25 30.012 16.3602 30.532 16.53C31.052 16.7015 31.274 16.8853 31.478 17.2072C31.88 17.8477 31.972 19.2968 32 21.5V25.0543C32.6823 25.123 33.3533 25.2598 34 25.462V21.4895C33.97 19.288 34.062 17.6762 33.23 16.3585C32.7854 15.6777 32.0776 15.1583 31.234 14.8937C30.358 14.605 29.314 14.5 28 14.5H25.992C25.9878 13.5753 25.5672 12.6893 24.8215 12.0341C24.0757 11.3789 23.0648 11.0074 22.008 11H21.984ZM22.004 12.75C23.122 12.75 24.004 13.5235 24.004 14.5C24.0067 14.7305 23.9568 14.9591 23.8572 15.1725C23.7576 15.3858 23.6104 15.5797 23.4242 15.7427C23.2379 15.9056 23.0164 16.0344 22.7725 16.1216C22.5287 16.2087 22.2674 16.2523 22.004 16.25C21.6097 16.2546 21.2229 16.1553 20.894 15.9649C20.5651 15.7745 20.3094 15.5019 20.16 15.1825C20.0575 14.9662 20.0052 14.7342 20.006 14.5C20.006 13.5235 20.888 12.75 22.006 12.75H22.004ZM16 21.5V23.25H28.024V21.5H16ZM16 25V26.75H25.348C26.149 26.1879 27.0541 25.7499 28.024 25.455V25H16ZM15.98 28.5V30.25H21.98V28.5H15.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 26.75C29.1435 26.75 27.363 27.3953 26.0503 28.544C24.7375 29.6926 24 31.2505 24 32.875C24 34.4995 24.7375 36.0574 26.0503 37.206C27.363 38.3547 29.1435 39 31 39C32.8565 39 34.637 38.3547 35.9497 37.206C37.2625 36.0574 38 34.4995 38 32.875C38 31.2505 37.2625 29.6926 35.9497 28.544C34.637 27.3953 32.8565 26.75 31 26.75ZM30 28.5H32V30.544C32 31.153 31.968 31.7112 31.906 32.2188C31.846 32.7263 31.768 33.2355 31.676 33.75H30.344C30.2407 33.2422 30.1573 32.7315 30.094 32.2188C30.0292 31.6623 29.9979 31.1033 30 30.544V28.5ZM31 35.5C31.2652 35.5 31.5196 35.5922 31.7071 35.7563C31.8946 35.9204 32 36.1429 32 36.375C32 36.6071 31.8946 36.8296 31.7071 36.9937C31.5196 37.1578 31.2652 37.25 31 37.25C30.7348 37.25 30.4804 37.1578 30.2929 36.9937C30.1054 36.8296 30 36.6071 30 36.375C30 36.1429 30.1054 35.9204 30.2929 35.7563C30.4804 35.5922 30.7348 35.5 31 35.5Z",
    fill: "#F22C42"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliancediligence);
export default __webpack_public_path__ + "static/media/Compliancediligence.8d4c9be4d53aa7980b2d68132a3cf5a3.svg";
export { ForwardRef as ReactComponent };